import { duplicateWithIndex } from "../../../helpers/duplicateWithIndex";

export default [
    {
        key: "pravaya_petlya",
        allArray: "allWardrobeDoors",
        activeArray: "activeWardrobeDoors",
        position: "bottom",
        extra: (el) => {
            el.userData.doorSide = "right";
        },
    },
    {
        key: "levaya_petlya",
        allArray: "allWardrobeDoors",
        activeArray: "activeWardrobeDoors",
        position: "bottom",
        extra: (el) => {
            el.userData.doorSide = "left";
        },
    },
    {
        key: "polka__shkaf", // polka__shkaf__sha
        allArray: "allPolkaWardrobe",
        activeArray: "activePolkaWardrobe",
        position: "top",
        extra: (el) => duplicateWithIndex(el, 4, servObj.allPolkaWardrobe),
    },
    {
        key: "yashchik__shkaf",
        allArray: "allYashchikWardrobe",
        activeArray: "activeYashchikWardrobe",
        position: "top",
        extra: (el) => duplicateWithIndex(el, 4, servObj.allYashchikWardrobe),
    },
    {
        key: "yashchik_bolshoy",
        allArray: "allYashchikWardrobeBig",
        activeArray: "activeYashchikWardrobeBig",
        position: "top",
        extra: (el) => duplicateWithIndex(el, 2, servObj.allYashchikWardrobeBig),
    },
];
